import { P2 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const TextWrapper = styled(P2)`
  p {
    min-height: 1em;
  }

  p,
  ul,
  ol {
    margin: 0;
  }

  ul,
  ol {
    padding-left: 22px;
  }

  li + li {
    margin-top: 12px;
  }

  margin-bottom: 24px;

  p + p,
  ol + ol,
  ul + ul {
    margin-top: 24px;
  }

  b {
    font-weight: ${themeStyle.fontBold};
  }

  h1,
  h2,
  h3,
  h4,
  h5 {
    font-size: ${themeStyle.fontSize18};
    font-weight: ${themeStyle.fontBold};
    margin: 0;
    margin-bottom: 12px;
  }

  a {
    cursor: pointer;
    text-decoration: underline;
  }
`;
